import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

  /* CSS Reset */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* Global box-sizing */
  *, *:before, *:after {
    box-sizing: border-box;
  }

  /* Fonts */
  /* 
   * Montserrat Font Weights:
   * 300 - Light
   * 400 - Regular
   * 500 - Medium
   * 600 - Semi-Bold
   * 700 - Bold
   * 800 - Extra-Bold
   * 900 - Ultra-Bold (Black)
   *
   * Usage examples:
   * font-weight: 300; // Light
   * font-weight: 400; // Regular (default)
   * font-weight: 500; // Medium
   * font-weight: 600; // Semi-Bold
   * font-weight: 700; // Bold
   * font-weight: 800; // Extra-Bold
   * font-weight: 900; // Ultra-Bold
   */
  body, button, input, textarea, select {
    font-family: 'Montserrat', 'Roboto', sans-serif;
    font-weight: 400; /* Regular weight as default */
  }

  /* Focus outline */
  *:focus {
    outline: 0;
  }

  /* Links */
  a {
    text-decoration: none;
    color: inherit;
  }

  /* Buttons */
  button {
    cursor: pointer;
    border: none;
    background: none;
  }

  /* Scrollbar - kept as requested in legacy global.ts but cleaned up */
   ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.gray}; 
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.textGray}; 
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.primary};
  }

 .react-datepicker-wrapper {
    width: 100% !important;
    display: block !important;
  }

  .react-datepicker__input-container {
    width: 100% !important;
    display: block !important;
  }

  /* --- POPUP FLUTUANTE (POSICIONAMENTO) --- */
  .react-datepicker-popper {
    z-index: 9999 !important;
    padding-top: 10px !important;
  }

  /* --- MAIN CALENDAR CONTAINER --- */
  .react-datepicker {
    font-family: inherit !important;
    border: 1px solid #dee2e6 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    background-color: white !important;
  }

  /* --- HEADER --- */
  .react-datepicker__header {
    background-color: #f3953f !important;
    border-bottom: none !important;
    border-radius: 8px 8px 0 0 !important;
    padding-top: 0.75rem !important;
  }

  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: #ffffff !important;
    font-weight: 600 !important;
  }

  /* --- DIAS --- */
  .react-datepicker__day {
    color: #495749ff !important;
    border-radius: 4px !important;
    transition: all 0.2s ease !important;

    &:hover {
      background-color: #fff3e6 !important;
      color: #f3953f !important;
    }
  }

  /* --- DIAS SELECIONADOS --- */
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: #f3953f !important;
    color: #ffffff !important;
    font-weight: 600 !important;

    &:hover {
      background-color: #e8863a !important;
    }
  }

  /* --- INTERVALO (RANGE) --- */
  .react-datepicker__day--in-range {
    background-color: #fff3e6 !important;
    color: #f3953f !important;
  }

  /* --- DIAS DESABILITADOS --- */
  .react-datepicker__day--disabled {
    color: #ced4da !important;
    cursor: not-allowed !important;

    &:hover {
      background-color: transparent !important;
    }
  }

  /* --- NAVIGATION (ARROWS) --- */
  .react-datepicker__navigation {
    top: 0.75rem !important;
  }

  .react-datepicker__navigation-icon::before {
    border-color: #ffffff !important;
  }

  .react-datepicker__navigation:hover *::before {
    border-color: #f8f9fa !important;
  }

  /* --- REMOVE TRIANGLE --- */
  .react-datepicker__triangle {
    display: none !important;
  }
`;

export default GlobalStyles;
